import { z } from 'zod';
import { EfemGatewayOverridesSchema } from './efem-gateway-config-schemas.js';
import { LocationGatewayOverridesPartialSchema } from './location-gateway-overrides.schema.js';
/** Site slug/id (e.g. `arjun-home-fremont`) — same as `FloorPlanSiteParamsSchema` / location deployment routes. */
const gatewayConfigSiteIdSchema = z.string().min(1).max(128);
/** Provider push by gateway serial — EFEM uses overrides; location uses site-scoped fields (validated in location-service). */
export const GatewayConfigPushBodySchema = z.object({
    siteId: gatewayConfigSiteIdSchema.optional(),
    overrides: EfemGatewayOverridesSchema.optional(),
    floorId: z.string().min(1).max(128).optional(),
    forwardingHost: z.string().optional(),
    forwardingPort: z.number().int().min(1).max(65535).optional(),
    pushTimeOverrides: LocationGatewayOverridesPartialSchema.optional(),
});
/** Provider tenant gateway overrides query (EFEM). */
export const GatewayTypeEfemQuerySchema = z.object({
    gatewayType: z.literal('efem'),
});
//# sourceMappingURL=gateway-config-push-api-schemas.js.map